import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { RouteIcon } from '@moia-dev/pace-icons'
import { RouteBuilderAreaRoutes } from './RouteBuilderAreaRoutes'

export const RouteBuilderAreaNavigationIcon = RouteIcon

export const RouteBuilderAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={RouteBuilderAreaRoutes.route}
      Icon={RouteIcon}
    />
  )
}
